import {ARTIFACT_MONEY} from 'app/utils/Consts';

export const isArtifactMoney = (type: string): boolean => type === ARTIFACT_MONEY;
